import { createSlice } from "@reduxjs/toolkit";
import { Juzgado } from "interfaces/promociones/promocionesInterface";
import { DataTiposCarpetas } from "interfaces/serviciosGenerales/serviciosGeneralesInterface";

type amnistiaState = {
  typePenal: boolean;
  lstJuzgados: Juzgado[];
  lstTipoCarpetas: DataTiposCarpetas[];
};

export const amnistiaSlice = createSlice({
  name: "ui",
  initialState: {
    typePenal: false,
    lstJuzgados: [],
    lstTipoCarpetas: [],
  } as amnistiaState,
  reducers: {
    onChangeAministiaType: (state, { payload }) => {
      state.typePenal = payload;
    },
    onAddLstJuzgados: (state, { payload }) => {
      state.lstJuzgados = payload;
    },
    onAddLstTipoCarpetas: (state, { payload }) => {
      state.lstTipoCarpetas = payload;
    },
    onResetAmnistia: (state) =>{
      state.typePenal = false;
      state.lstJuzgados = [];
      state.lstTipoCarpetas = []
    }
  },
});

export const { onChangeAministiaType, onAddLstJuzgados, onAddLstTipoCarpetas ,onResetAmnistia} =
  amnistiaSlice.actions;
